import apiRequest from "apiRequest";
import { endPoints } from "apis";

export const fetchCustomers = async (params = {}) => {
  return apiRequest.get(endPoints.GET_CUSTOMERS, params);
};

export const fetchCustomerById = async (id, params = {}) => {
  return apiRequest.get(`${endPoints.GET_SINGLE_CUSTOMER}/${id}`, params);
};

export const fetchCustomerOrders = async (id, params = {}) => {
  return apiRequest.get(`${endPoints.GET_CUSTOMER_ORDERS}/${id}`, params);
};
